/**
 * Systems View - Public Access
 * No permission checks - available to all users
 */

import React from 'react';
import SystemsView from '../features/fullValueChain/SystemsView';

const PermissionAwareSystemsView: React.FC = () => {
  // Public access - no permission checks
  return <SystemsView />;
};

export default PermissionAwareSystemsView;
